import Cookies from "js-cookie";
import { io } from "socket.io-client";

const URL = process.env.REACT_APP_SOCKET_SERVER_URL;
const userToken = Cookies.get("access_token");

export const socket = io(URL, {
  path: "/realtime",
  transports: ["websocket"],
  auth: {
    token: userToken,
  },
  autoConnect: false,
});

const FeedURL = process.env.REACT_APP_FEED_SOCKET_URL;
export const feedSocket = io(FeedURL, {
  path:"/realtime",
  transports : ["websocket"],
  auth:{
    token: userToken,
  },
  autoConnect:false
})